import React from "react";
import ReactDOM from "react-dom";
import Root from "~/root";
import * as serviceWorker from "./serviceWorker";
import { setupAxiosInterceptors } from "~/api/axios.config";
import { persistor, store } from "./store";
import { PersistGate } from "redux-persist/lib/integration/react";
import { Provider } from "react-redux";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";

if (typeof window !== "undefined") {
  setupAxiosInterceptors();
}

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={<LoadableLoading />} persistor={persistor}>
      <Root />
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
